// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"component-grid"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3H21V21H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 3V21M15 3V21M21 9L3 9M21 15L3 15M3 3H21V21H3V3Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-component-grid')
export default class ComponentGridIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-grid',
    }
  }
}
